





























































import {
  SfHeader,
  // SfBadge,
  SfButton,
} from '@storefront-ui/vue';
import { usePageStore } from "~/stores/page";
import {
  ref,
  defineComponent,
  useRouter,
  onMounted,
  useFetch, useContext,
} from '@nuxtjs/composition-api';
// import HeaderNavigation from '~/components/Header/Navigation/HeaderNavigation.vue';
// import { useCategory } from '~/modules/catalog/category/composables/useCategory';
import {
  useUiHelpers,
} from '~/composables';
// import { useCart } from '~/modules/checkout/composables/useCart';
// import { useWishlist } from '~/modules/wishlist/composables/useWishlist';
import { useUser } from '~/modules/customer/composables/useUser';
// import { useWishlistStore } from '~/modules/wishlist/store/wishlistStore';
// import type { CategoryTree, ProductInterface } from '~/modules/GraphQL/types';
import type { CategoryTree } from '~/modules/GraphQL/types';
import HeaderLogo from '~/components/HeaderLogo.vue';
// import SvgImage from '~/components/General/SvgImage.vue';
import { GlobalGtmEventHelper } from "~/helpers/bindGlobalGtmEvent";
import { useTopBar } from './TopBar/useTopBar';
import HeaderTopMenu from '~/components/Header/TopMenu/HeaderTopMenu.vue';
import { useMenu } from '~/composables/useMenu';
import RelatedSite from '~/components/General/RelatedSite.vue';
import { useConfig, useGtm } from "~/composables";
// import MenuMockData from '~/components/Header/TopMenu/mocks/menu';

export default defineComponent({
  components: {
    HeaderTopMenu,
    SfHeader,
    HeaderLogo,
    // SvgImage,
    SfButton,
    // SfBadge,
    RelatedSite,
    CurrencySelector: () => import('~/components/CurrencySelector.vue'),
    StoreSwitcher: () => import('~/components/StoreSwitcher.vue'),
    SearchBar: () => import('~/components/Header/SearchBar/SearchBar.vue'),
    // SearchResults: () => import(
    //   /* webpackPrefetch: true */ '~/components/Header/SearchBar/SearchResults.vue'
    // ),
  },
  setup() {
    const { pageData } = usePageStore();
    const { eventCustomlinksInteracted } = useGtm();
    const { bindGlobalGtmEvent } = GlobalGtmEventHelper();
    const { config } = useConfig();
    const showTopNotification = Boolean(Number(config.value.show_top_notification));
    const router = useRouter();
    const { app } = useContext();
    // const { toggleCartSidebar, toggleWishlistSidebar, toggleLoginModal } = useUiState();
    const { setTermForUrl, getCatLink } = useUiHelpers();
    const { isAuthenticated } = useUser();
    // const { loadTotalQty: loadCartTotalQty, cart } = useCart();
    // const { loadItemsCount: loadWishlistItemsCount } = useWishlist();
    // const { categories: categoryList, load: categoriesListLoad } = useCategory();
    const { loadTopMenu } = useMenu();

    const { hasCurrencyToSelect, hasStoresToSelect } = useTopBar();

    const isSearchOpen = ref(true);

    // const wishlistStore = useWishlistStore();
    // const wishlistItemsQty = computed(() => wishlistStore.wishlist?.items_count ?? 0);

    // const wishlistHasProducts = computed(() => wishlistItemsQty.value > 0);
    // const accountIcon = computed(() => (isAuthenticated.value ? 'profile_fill' : 'profile'));
    const categoryTree = ref<CategoryTree[]>([]);

    const isShowNav = ref(false);
    const topheader = ref(null);
    // const handleAccountClick = async () => {
    //   if (isAuthenticated.value) {
    //     await router.push(app.localeRoute({ name: 'customer-my-profile' }));
    //   } else {
    //     toggleLoginModal();
    //   }
    // };
    const showNavForMobile = function () {
      if (document && isShowNav.value) {
        document.body.classList.add('no-scroll');
        document.getElementById('__layout').className = '';
      } else {
        document.body.classList.remove('no-scroll');
        showTopNotification && (document.getElementById('__layout').className = 'show-top-notification');
      }
    };
    const removeNoScroll = function () {
      if (document.body.clientWidth >= 1200) {
        document.body.classList.remove('no-scroll');


      } else if (isShowNav.value) {
        document.body.classList.add('no-scroll');
      }
    };

    const topMenuData = ref([]);
    useFetch(async () => {
      // topMenuData.value = MenuMockData;
      const data = await loadTopMenu();
      topMenuData.value = data['versionsCmsTopMenu'];
    });
    const toHideNav = function () {
      isShowNav.value = false;
      if (window.scrollY === 0) {
        showTopNotification && (document.getElementById('__layout').className = 'show-top-notification');
        document.body.classList.remove('no-scroll');
      }
    };
    const redirectLinks = async () => {
      const url = '/contact?subject=' + pageData?.pageTitle;
      const redirectUrl = app.localeRoute(url);
      await router.push(redirectUrl);
    };
    onMounted(async () => {
      const { $config } = useContext();
      if ($config.cookieLawKey) {
        const cookieLaw = document.createElement("script");
        cookieLaw.setAttribute(
          "src",
          "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        );
        cookieLaw.setAttribute(
          "data-domain-script",
          $config.cookieLawKey
        );
        cookieLaw.setAttribute(
          "charset",
          "UTF-8"
        );
        cookieLaw.setAttribute(
          "fetchpriority",
          "low"
        );
        cookieLaw.setAttribute(
          "data-document-language",
          "true"
        );
        cookieLaw.setAttribute(
          "rel",
          "prefetch"
        );
        cookieLaw.async = true;
        document.body.appendChild(cookieLaw);

        const cookieLaw2 = document.createElement("script");
        cookieLaw2.text = 'function OptanonWrapper() { }';
        document.body.appendChild(cookieLaw2);

        const useDefaultWhenEmpty = (str, defaultValue = '') => {
          if(str === null || str === '') {
            return defaultValue;
          } else {
            return str;
          }
        };

        bindGlobalGtmEvent('#ot-sdk-btn-floating button, button#close-pc-btn-handler', (e) => {
          eventCustomlinksInteracted({
            'eventlabel': useDefaultWhenEmpty(e.getAttribute('aria-label'), 'Close'),
            'eventCategory': 'Cookie Banner'
          });
        });

        bindGlobalGtmEvent('button.save-preference-btn-handler.onetrust-close-btn-handler,'
          + ' button.ot-floating-button__close svg, button.ot-floating-button__close g,'
          + ' button.ot-floating-button__close polygon', (e) => {
          eventCustomlinksInteracted({
            'eventlabel': useDefaultWhenEmpty(e.textContent, 'Close'),
            'eventCategory': 'Cookie Banner'
          });
        });

        bindGlobalGtmEvent('#ot-pc-desc a', (e) => {
          eventCustomlinksInteracted({
            'eventlabel': useDefaultWhenEmpty(e.textContent, 'Close'),
            'eventCategory': 'Cookie Banner'
          });
        });
      }

      if ($config.baiduTongjiKey) {
        const hm = document.createElement("script");
        hm.setAttribute(
          "src",
          "https://hm.baidu.com/hm.js?" + $config.baiduTongjiKey
        );
        hm.setAttribute(
          "fetchpriority",
          "low"
        );
        hm.setAttribute(
          "rel",
          "prefetch"
        );
        hm.async = true;
        document.body.appendChild(hm);

        const hm2 = document.createElement("script");
        hm2.text = 'var _hmt = _hmt || [];';
        document.body.appendChild(hm2);
      }
      // if (app.$device.isDesktop) {
      //   await loadCartTotalQty();
      //   // eslint-disable-next-line promise/catch-or-return
      //   await loadWishlistItemsCount();
      // }

      // window.addEventListener('click', showNavForMobile);
      window.addEventListener('resize', removeNoScroll);

    });

    return {
      topMenuData,
      // accountIcon,
      // cartTotalItems: computed(() => cart.value?.total_quantity ?? 0),
      categoryTree,
      getCatLink,
      // handleAccountClick,
      isAuthenticated,
      isSearchOpen,
      setTermForUrl,
      // toggleCartSidebar,
      // toggleWishlistSidebar,
      // wishlistHasProducts,
      // wishlistItemsQty,
      hasCurrencyToSelect,
      hasStoresToSelect,
      isShowNav,
      topheader,
      toHideNav,
      showNavForMobile,
      eventCustomlinksInteracted,
      redirectLinks
    };
  },
});
